import { Text } from "@gcs/design-system/react";
import styled from "styled-components/macro";
import ContentSlider from "components/CnpAssurance/Slider/ContentSlider";
import * as S from "components/common/PresenceInfo/PresenceInfoFactory.style"

export const Content = styled.section(({ theme }) => ({
  ...S.ContentFactory({theme}),
  padding: "0 16px 40px 16px",
  color: theme.color.brandPrimary.light,
  borderBottom: "1px solid #E3E0E2"
}));


export const Title = styled(Text)(({ theme }) => ({
  ...S.TitleFactory({ theme }),
  marginBottom: "40px",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.xl()]: {
    margin: "0",
  },
}));

export const CardInfo = styled.div(({ theme, active }) => ({
  ...S.CardInfoFactory({theme, active}),
}));

export const CardIcon = styled.img(({ theme }) => ({
  ...S.CardIconFactory(),
  width: "45px",
  height: "45px",
}));

export const CardContainer = styled.div(({ theme }) => ({
  ...S.CardContainerFactory(),
  borderLeftColor: "#E3E0E2",
}));

export const CardTitle = styled(Text)(({ theme }) => ({
  ...S.CardTitleFactory({ theme }),
  color: theme.color.brandPrimary.light,
}));

export const Description = styled(Text)(({ theme }) => ({
  ...S.DescriptionFactory({ theme }),
  color: theme.color.brandPrimary.light,
}));

export const SlideCard = styled(ContentSlider)(({ theme }) => ({
  ...S.SliderCardFactory({theme})
}));

export const Paragraph = styled(Text)(({ theme }) => ({
  ...S.ParagraphFactory(),

  textAlign: "center",
  color: theme.color.brandPrimary.light,
  marginTop: "150px",
}));

export const Container = styled(S.ContainerFactory)(() => ({
  display: "inline-grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "30px"
}));
export const ContainerContent = styled(S.ContainerContentFactory)(() => ({
  gap: "32px",
  display: "grid"
}));
export const DesktopOnly = S.DesktopOnlyFactory;
export const MobileOnly = S.MobileOnlyFactory;
export const ContainerImage = S.ContainerImageFactory;
